<div class="iptv-dialog">
  <div>
    <div class="confirmation-message" style="padding: 1em;">
      <h1 class="delete-title">Notice</h1>
      <div data-testId="message-dialog-content" class="mt-4">{{ data }}</div>
    </div>
    <div mat-dialog-actions class="dialog-buttons"
         style="padding-bottom: 2em; display: flex; justify-content: flex-end;">
      <button data-testId="message-dialog-close-button"
              mat-stroked-button mat-dialog-close color="basic">
        Close
      </button>
    </div>
  </div>
</div>
